import { useEffect, useState } from 'react';
import { whatsNewApi } from '../services/api';

/**
 * «Что нового»: сводка для шапки (счётчик, важное для окна, пункты меню с NEW). Один опрос на всю страницу:
 * хук можно вызывать из колокольчика, окна и меню — данные общие. Опрос раз в 5 минут и при возврате во вкладку.
 */
const store = { data: null, subs: new Set(), timer: null, busy: false, started: false };
const EMPTY = { count: 0, major: [], nav: [] };

function emit() { store.subs.forEach((f) => f(store.data || EMPTY)); }

export async function refreshWhatsNew() {
  if (store.busy) return;
  store.busy = true;
  try {
    store.data = (await whatsNewApi.summary()).data;
    emit();
  } catch (e) {
    // 401/403 — не опрашиваем дальше; остальное — тихо, шапка не должна шуметь ошибками
    const st = e?.response?.status;
    if (st === 401 || st === 403) stop();
  } finally { store.busy = false; }
}

function start() {
  if (store.started) return;
  store.started = true;
  refreshWhatsNew();
  store.timer = setInterval(() => { if (!document.hidden) refreshWhatsNew(); }, 5 * 60 * 1000);
  document.addEventListener('visibilitychange', onVisible);
}
function onVisible() { if (!document.hidden) refreshWhatsNew(); }
function stop() {
  clearInterval(store.timer);
  document.removeEventListener('visibilitychange', onVisible);
  store.started = false;
}

export function setWhatsNewSummary(d) { store.data = d; emit(); }

export default function useWhatsNew(enabled = true) {
  const [d, setD] = useState(store.data || EMPTY);
  useEffect(() => {
    if (!enabled) return undefined;
    store.subs.add(setD);
    start();
    return () => {
      store.subs.delete(setD);
      if (!store.subs.size) stop();
    };
  }, [enabled]);
  return d;
}
